var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorseToy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m16.75 14.213-.29-3.41c-.121-1.644-.847-3.147-1.992-4.124-1.763-1.505-4.037-1.82-6.015-.93M6.885 15.318l.11-.412c.065-.248.185-.734.313-1.264.41-1.695 1.976-2.866 3.716-2.754l.128.01a3.596 3.596 0 0 1 3.14 2.581c.16.547.313 1.072.385 1.337l.126.502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.309 13.49a.468.468 0 0 1-.024.648 10.699 10.699 0 0 1-7.431 2.988c-3.038 0-5.78-1.262-7.734-3.29a.47.47 0 0 1 .671-.655 9.841 9.841 0 0 0 7.051 2.963c2.762 0 5.013-1.025 6.781-2.698a.469.469 0 0 1 .673.03l.013.014v0ZM3.114 2.994a5.712 5.712 0 0 1-.103-1.579.209.209 0 0 1 .11-.164c.138-.076.258.052.339.165l.743 1.034M4.203 2.449c.05-.493.198-.807.435-1.243.057-.104.147-.22.264-.205.122.016.177.16.206.279l.327 1.314M1.188 5.256c.466.07.91.303 1.224.656.341.382.526.897.516 1.408"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.73 6.078S6.032 2.604 5.097 2.436c-.599-.107-1.224.045-1.736.374-.51.33-.921.792-1.321 1.25-.323.37-.649.751-.85 1.194l-.125.34c-.132.498-.07 1.067.284 1.436.329.343.84.44 1.316.355l.264-.066c.037-.012.073-.025.108-.04.562-.222 1.01-.655 1.442-1.076l1.18 2.242-.006.003a6.437 6.437 0 0 0-.638 2.67l-.08 3.093"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M3.596 4.544a.37.37 0 0 0 .035.201c.072.151.236.263.404.247.18-.018.327-.177.356-.353m0 0a.363.363 0 0 0-.01-.17l.01.17ZM13.388 5.935c.002.045.003.09.003.136 0 1.313-.773 2.377-1.727 2.377h-.969c-.953 0-1.726-1.064-1.726-2.377 0-.186.015-.366.044-.54M19 6.217c-.033.558-.097 1.34-.097 1.34l-3.995-.83s3.627-.381 4.091-.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorseToy);
export default __webpack_public_path__ + "static/media/horse-toy.f69c6421.svg";
export { ForwardRef as ReactComponent };